module.exports = __webpack_public_path__ + "static/media/main-banner.0f60665d.png";